import { render, staticRenderFns } from "./CopiarCadastro.vue?vue&type=template&id=076132ec&"
import script from "./CopiarCadastro.vue?vue&type=script&lang=js&"
export * from "./CopiarCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports